<template>
  <div class="name">

    <el-row class="bgW">
      <el-col :span="20">
        <el-form class="search" :inline="true" label-suffix="：" size="mini" :model="search">
          <el-form-item label="产品名称">
            <el-input
              v-model="search.name"
              maxlength="30"
              clearable
              placeholder="请输入产品名称"
            />
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="search.status" clearable placeholder="请选择状态">
              <el-option
                v-for="item in options.statusList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="4" style="text-align: right;">
        <el-button type="primary" icon="el-icon-search" size="mini" @click="getList('search')">搜索</el-button>
        <el-button type="primary" size="mini" @click="getList('resetForm')">重置</el-button>
      </el-col>
    </el-row>
    <div>
      <el-button type="primary" size="mini" icon="el-icon-plus" @click="openDialog">添加</el-button>
    </div>
    <div class="accountCon">
      <el-row>
        <el-col :span="24">
          <el-table
            :data="list"
            size="small"
            border
            :cell-style="$style.cellStyle"
            :header-cell-style="$style.rowClass"
          >
            <ElTableColumn label="编码" prop="code" width="100" />
            <ElTableColumn label="产品名称" prop="name" />
            <ElTableColumn label="规格" prop="spec" />
            <ElTableColumn label="价格" prop="price" />
            <ElTableColumn label="状态" width="150">
              <template slot-scope="{ row }">
                <el-switch
                  v-model="row.status"
                  :active-value="1"
                  :inactive-value="2"
                  active-text="启用"
                  inactive-text="禁用"
                  @change="handleStatusChange(row)"
                />
              </template>
            </ElTableColumn>
          </el-table>
          <pagination
            class="page tc mt10"
            :total="page.total"
            :page.sync="page.page"
            :limit.sync="page.pagesize"
            @pagination="getList"
          />
        </el-col>
      </el-row>
    </div>

    <el-dialog
      title="添加产品"
      :visible.sync="dialogVisible"
      width="500px"
      :close-on-click-modal="false"
      @close="resetForm"
    >
      <el-form
        ref="formRef"
        :model="form"
        label-width="100px"
        label-suffix="："
        size="mini"
        :rules="rules"
      >
        <el-form-item label="编码" prop="code">
          <el-input v-model="form.code"  clearable placeholder="请输入编码" />
        </el-form-item>
        <el-form-item label="产品名称" prop="name">
          <el-input v-model="form.name" clearable placeholder="请输入产品名称" />
        </el-form-item>
        <el-form-item label="规格" prop="spec">
          <el-input v-model="form.spec" clearable placeholder="请输入规格" />
        </el-form-item>
        <el-form-item label="价格" prop="price">
          <el-input v-model="form.price" clearable placeholder="请输入价格" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="dialogVisible = false">取消</el-button>
        <el-button size="mini" type="primary" @click="submitForm">确认保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import pagination from '@/components/Pagination'
import { getMaterialList, createMaterial, updateMaterialStatus } from '@/api/goods'

class Page {
  total = 0;
  page = 1;
  pagesize = 10;
}
class Search {
  name = ''; // 搜索内容
  status = ''; // 1启用 2禁用
}
class Form {
  code = '';
  name = '';
  spec = '';
  price = '';
}
class Options {
  statusList = [
    { label: '启用', value: 1 },
    { label: '禁用', value: 2 }
  ];
}
export default {
  name: 'MaterialList',
  components: {
    pagination
  },
  data() {
    return {
      search: new Search(),
      page: new Page(),
      options: new Options(),
      form: new Form(),
      list: [],
      dialogVisible: false,
      rules: {
        code: [{ required: true, message: '请输入编码', trigger: 'blur' }],
        name: [{ required: true, message: '请输入产品名称', trigger: 'blur' }],
      }
    }
  },
  mounted() {
    this.getList();
  },
  methods: {
    // 获取列表
    getList(option) {
      if (option === 'resetForm') { this.search = new Search(); this.page = new Page(); }
      if (option === 'search') this.page = new Page();
      getMaterialList({ ...this.search, ...this.page }).then(res => {
        this.list = res.data.list;
        this.page.total = res.data.dataCount;
      });
    },
    // 打开添加弹窗
    openDialog() {
      this.form = new Form();
      this.dialogVisible = true;
    },
    resetForm() {
      this.form = new Form();
      this.$refs.formRef && this.$refs.formRef.clearValidate();
    },
    // 保存
    submitForm() {
      this.$refs.formRef.validate(valid => {
        if (!valid) return;
        createMaterial({ ...this.form }).then(res => {
          this.$message({
            type: 'success',
            message: res.msg || '添加成功'
          });
          this.dialogVisible = false;
          this.getList('search');
        });
      });
    },
    // 上下架/启用禁用
    handleStatusChange(row) {
      updateMaterialStatus({ id: row.id, status: row.status }).then(res => {
        this.$message({
          type: 'success',
          message: res.msg
        });
      }).catch(() => {
        row.status = row.status === 1 ? 2 : 1;
      });
    }
  }
}
</script>

<style lang="scss" scoped>

.bgW {
  background: #fff;
  border-radius: 3px;
  margin-bottom: 20px;
}
.accountCon {
  background: #fff;
  padding: 10px 0 80px;
}
</style>
